module.exports = __webpack_public_path__ + "static/media/fa-regular-400.3351f435.eot";